import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="special-condition-modal"
export default class extends Controller {
  connect() {
  }

  // リセットボタン
  reset() {
    // モーダル内の全てのチェックボックスを取得
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"]') as NodeListOf<HTMLInputElement>;
    // 全てのチェックボックスをOFFにする
    checkboxes.forEach(checkbox => {
      checkbox.checked = false
    })
  }

  // 「決定する」ボタンクリック時の処理
  submitSpecialConditionSettings() {
    // 選択した job_special_conditions.id と job_special_conditions.name を取得
    const selectedCheckboxes = Array.from(document.querySelectorAll('input[name="condition"]:checked')) as HTMLInputElement[];
    const selectedNames = selectedCheckboxes.map(checkbox => checkbox.nextElementSibling?.textContent || '').join(' / ');
    const selectedValues = selectedCheckboxes.map(checkbox => checkbox.value).join(',');

    // 選択した job_special_conditions.name のリストを表示する箇所
    const selectedNamesElement = document.getElementById('selected_special_condition_names') as HTMLParagraphElement;
    selectedNamesElement.textContent = selectedNames || '選択してください';

    // 選択した job_special_conditions.id のリストをフォームのhiddenフィールドにセット
    const selectedIdsElement = document.getElementById('special_condition_ids') as HTMLInputElement;
    selectedIdsElement.value = selectedValues;

    // モーダルを閉じる
    Modal.getOrCreateInstance(document.getElementById('selectConditionModal') as HTMLElement).hide();
  }
}
